
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import {
  CourseAssessmentQuestionTypeEnum,
  CourseAssessmentTypeEnum,
  CourseSectionEnum,
} from "@/constants/enum.constant";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";

@Component({
  components: {},
  filters,
})
export default class MyCourseEvaluation extends Vue {
  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: 1 })
  private maxSteps!: number;
  @Prop({ default: null })
  private course!: any;

  private assessment = this.course?.pre_test;

  @Watch("step")
  private onStep() {
    if (this.step <= this.preTestTotalQuestion) {
      this.assessment = this.course?.pre_test;
    } else {
      this.assessment = this.course?.post_test;
    }
  }

  private get isPreTest() {
    return this.assessment?.type === CourseAssessmentTypeEnum.PRE_TEST;
  }
  private get isPostTest() {
    return this.assessment?.type === CourseAssessmentTypeEnum.POST_TEST;
  }
  private get preTestTotalQuestion() {
    return _.sum(
      this.course?.pre_test.sections.map((section) => section.questions.length)
    );
  }
  private get postTestTotalQuestion() {
    return _.sum(
      this.course?.post_test.sections.map((section) => section.questions.length)
    );
  }
  private get questionIndex() {
    return this.currentAssessmentQuestion - 1;
  }
  private get questions() {
    return (
      this.assessment?.sections.map((section) => section.questions).flat() || []
    );
  }
  private get isLastStep() {
    return this.currentAssessmentQuestion === this.questions.length;
  }

  private get currentAssessmentQuestion() {
    return this.isPreTest
      ? this.step
      : this.step - this.preTestTotalQuestion;
  }

  private switchAssessment(targetAssessment: any) {
    if (!targetAssessment || targetAssessment === this.assessment) return;

    const sourceTotal = this.questions.length;
    const targetTotal = _.sum(
      targetAssessment.sections.map((section) => section.questions.length)
    );
    const currentQuestion = Math.max(1, this.currentAssessmentQuestion);
    const targetQuestion = currentQuestion === sourceTotal
      ? targetTotal
      : Math.min(currentQuestion, targetTotal);
    const targetStep = targetAssessment.type === CourseAssessmentTypeEnum.PRE_TEST
      ? targetQuestion
      : this.preTestTotalQuestion + targetQuestion;

    this.assessment = targetAssessment;
    this.$emit("nextStep", targetStep);
  }

  private isShortText(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.SHORT_TEXT;
  }
  private isLongText(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.LONG_TEXT;
  }
  private isMultipleChoices(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.MULTIPLE_CHOICES;
  }
  private isCheckbox(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.CHECKBOX;
  }
  private isDropdown(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.DROPDOWN;
  }
  private isFile(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.FILE;
  }
  private isScale(data: any) {
    return data.type === CourseAssessmentQuestionTypeEnum.SCALE;
  }

  private prev() {
    if (this.step === 1) return;
    this.$emit("nextStep", this.step - 1);
  }

  private next() {
    this.$emit("nextStep", this.step + 1);
  }
}
